import React from 'react';
import { Container, Row, Col, Button, Card, CardBody, ListGroup, ListGroupItem, CardTitle, CardText  } from 'reactstrap';
import { AUAContainer } from '../AUA';
import { T } from '../traks';
import { R } from '../routes';
import { PremiumInit } from '../c/PremiumModal';

function PremiumInner(props) {
    const { aua } = props;
    const subscription = aua.me && aua.me.Subscription ? aua.me.Subscription : 'free';

    let subscriptionStatus = <T>Not Premium</T>
    if (subscription !== 'free') {
        subscriptionStatus = <T>Premium</T>
    }

    const goToGames = () => {
        R.goto_url('games');
    }

    const goToNewGame = () => {
        R.goto_url('new_game');
    }

    const triggerPremiumModal = () => {
        PremiumInit();
    }

    return (
		<Container>
			<Row className="py-4 text-center">
				<Col>
					<T>
					<h2>Get even more out of Aktiedysten!</h2>
					<p>When you upgrade to Premium, you get access to create games with many more options.<br />
					You choose how many users you want to invite to your Premium games (see price per invite below)</p>
					</T>
				</Col>
			</Row>

			<Row className="pt-4">
				<Col>
					<div className="d-flex justify-content-between">
						<div>
							<h3><T>Your status:</T> <span className={subscription === 'free' ? 'not-premium-red' : 'premium-green'}>{subscriptionStatus}</span></h3>
						</div>
						<div className="d-flex justify-content-right">
							<Row>
								<Button onClick={goToGames} className="ml-auto mb-auto mr-2 px-4 py-2"><T>Go to games</T></Button>
								<Button onClick={triggerPremiumModal} className="ml-auto mb-auto ad_new_game_button px-4 py-2"><T>Upgrade</T></Button>
							</Row>
						</div>
					</div>
				</Col>
			</Row>
			<div className="py-3 ad_xtab_unselected">	
			</div>
			<Row className="py-3 mt-4 ad_game_box">
					<Col md="12" className="pl-5 pr-5">
						<T>
						<h4>In the Premium game on Aktiedysten you get a wide range of new possibilities:</h4>
						<ol>
							<li>You can trade several different assets. In addition to shares, you can also trade bonds, ETFs, commodities, etc.</li>
							<li>You can decide the duration of your game, even up to 1 year.</li>
							<li>You can access a wide range of information about companies, such as key figures, industry information, company description, etc.</li>
							<li>You can see the risk score of assets and compete to see who creates the highest risk-weighted value. This way, you don't just win on pure return, but on finding the right balance between risk and opportunity for return.</li>
						</ol>
						</T>
						<div className="py-5">
							<img alt='premium' src='https://static.aktiedysten.dk/imgs/premium-image-0.png' style={{width: "100%"}} />
						</div>
						<T>
						<p>At the top of the page you can upgrade to Premium. If you are already a Premium user, you can purchase invitations.<br />
						We will process your upgrade request as soon as possible. Usually your upgrade will be approved within 24 hours. You can then start your Premium game.</p>

						<p><strong>Long term discounts and opportunities for different users</strong><br />
						If you choose to subscribe to a number of Premium Invitations for a longer period of time, you get a discount. This is of course an advantage if you want to organise a game with a long duration, but it can also be an advantage if you want to run several shorter games with different participants. The invitations are not personalised. For example, you can subscribe to 50 invitations for a year (at a discount) - and play for six months with 50 people and for the next six months with 50 other people. You choose who is in the game.</p>
						</T>
					</Col>
					<Col md="12" className="price-table-premium mt-4 pl-5 pr-5"> 
						<Row>
							<Col className="mt-2">
								<Card className="card-grey">
									<CardBody className="text-center">
										<CardTitle tag="h5">
										<T>Free of charge</T>
										</CardTitle>
										<CardText>
										<h3><T>0 kr.</T></h3><br />
										<T>per month. per invitation</T>
										</CardText>
									</CardBody>
									<ListGroup flush>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Game length up to 30 days</T>
										</ListGroupItem>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Unlimited number of games</T>
										</ListGroupItem>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Up to 1 stock market per game</T>
										</ListGroupItem>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Up to 30 players per game</T>
										</ListGroupItem>
									</ListGroup>
									<CardBody className="text-center">
										<Button onClick={goToNewGame} className="ml-auto mb-auto ad_new_game_button px-4 py-2">
											<T>Submit</T>
										</Button>
									</CardBody>
								</Card>
							</Col>
							<Col className="mt-2">
								<Card className="card-green">
									<CardBody className="text-center">
										<CardTitle tag="h5">
										<T>Annual subscription</T>
										</CardTitle>
										<CardText>
										<h3><T>12 kr.</T></h3><br />
										<T>per month. per invitation</T>
										</CardText>
									</CardBody>
									<ListGroup flush>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Game length up to 365 days</T>
										</ListGroupItem>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Unlimited number of games</T>
										</ListGroupItem>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Unlimited stock markets per game including bonds, funds and indices, and commodities</T>
										</ListGroupItem>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Number of players is at your discretion</T>
										</ListGroupItem>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Manage your players</T>
										</ListGroupItem>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Telephone support</T>
										</ListGroupItem>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Visualise risk as a competitive paramete</T>
										</ListGroupItem>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Information and accounting figures on assets</T>
										</ListGroupItem>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Game design with skin and colours</T>
										</ListGroupItem>
									</ListGroup>
									<CardBody className="text-center">
										<Button onClick={triggerPremiumModal} className="ml-auto mb-auto ad_new_game_button px-4 py-2">
											<T>Submit</T>
										</Button>
										<p><small><T>Prices are excl. VAT</T></small></p>
									</CardBody>
								</Card>
							</Col>
							<Col className="mt-2">
								<Card className="card-blue">
									<CardBody className="text-center">
										<CardTitle tag="h5">
											<T>Per month</T>
										</CardTitle>
										<CardText>
										<h3><T>24 kr.</T></h3><br />
										<T>per month. per invitation</T>
										</CardText>
									</CardBody>
									<ListGroup flush>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Game length up to 365 days</T>
										</ListGroupItem>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Unlimited number of games</T>
										</ListGroupItem>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Unlimited stock markets per game including bonds, funds and indices, and commodities</T>
										</ListGroupItem>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Number of players is at your discretion</T>
										</ListGroupItem>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Manage your players</T>
										</ListGroupItem>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Telephone support</T>
										</ListGroupItem>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Visualise risk as a competitive parameter</T>
										</ListGroupItem>
										<ListGroupItem>
											<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/> <T>Information and accounting figures on assets</T>
										</ListGroupItem>
									</ListGroup>
									<CardBody className="text-center">
										<Button onClick={triggerPremiumModal} className="ml-auto mb-auto ad_new_game_button px-4 py-2">
											<T>Submit</T>
										</Button>
										<p><small><T>Prices are excl. VAT</T></small></p>
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Col>
					<Col md="12" className="mt-4 pl-5 pr-5">
						<T>
						<h2>FAQ</h2>
						<p><strong>Can I use Aktiedysten commercially?</strong></p>
						<p>No, you may not use Aktiedysten commercially without first entering into an agreement with Aktiedysten. Commercial means the use of Aktiedysten for recruitment and/or outreach to non-existing customers/users. For commercial use, an additional fee of DKK 10,000 excluding VAT will be charged.</p>

						<p><strong>Am I the only one who becomes premium?</strong></p>
						<p>When you upgrade to premium, you will have access to the benefits that come with it. Likewise, the players you invite to your games will have premium benefits on the games they are invited to by you.<br />
						The invitations are not personalised, which means that you can transfer a key from one user to another if you wish. However, you can only have the number of Invitations in use at the same time that you have purchased.</p>

						<p><strong>How long is my premium valid for?</strong></p>
						<p>If you have chosen a monthly subscription, your Premium status will automatically renew until you cancel the subscription. If you have chosen a 1-year subscription, we will contact you one month before expiry.<br />
						When you cancel your subscription, it will stop at the end of the month you cancel your subscription.</p>

						<p><strong>What does a premium invitation cover?</strong></p>
						<p>An invitation gives you access to Aktiedysten's premium content, including more markets, key figures and visualisation of risk.<br />
						You as an administrator decide who should have premium access. The invitations are not personalised, which means that you can transfer a key from one user to another if you wish. However, you can only have the number of Invitations in use at the same time that you have purchased.</p>

						<p><strong>What if I have started a game and am no longer premium?</strong></p>
						<p>If you have started a game but cancel your subscription, your game will automatically be cancelled at the end of the premium period.<br />
						The users you have invited will no longer have premium benefits.</p>

						<p><strong>Who can I share my premium invitations with?</strong></p>
						<p>You as the administrator decide who should have premium access. The invitations are not personalised, which means you can transfer a key from one user to another if you wish. However, you can only have the number of invitations in use at the same time that you have purchased</p>

						<p><strong>What is the maximum amount of premium invitations I can include in my package?</strong></p>
						<p>You decide how many Invitations you want to open up. However, you can only have the number of Invitations in use that you have purchased.</p>

						<p><strong>How can I keep track of how many Invitations I have?</strong></p>
						<p>You can always contact us at <a href="mailto:info@aktiedysten.dk">info@aktiedysten.dk</a> to find out how many Invitations you have left and how long your subscription runs for. <br />
						You as the administrator decide who should have premium access. The invitations are not personalised, which means that you can transfer a key from one user to another if you wish. However, you can only have the number of Invitations in use at the same time that you have purchased.<br />
						For example, you can subscribe to 50 invitations for a year (at a discount) - and play for six months with 50 people and for the next six months with 50 other people. You choose who is in the game.</p>

						<p><strong>Can I buy single games</strong></p>
						<p>When you upgrade to premium, it's a subscription you start. However, you can cancel your subscription at any time at the end of the month.</p>

						<p><strong>How am I charged for premium invitations?</strong></p>
						<p>You can choose between paying per month at 24 kr. per invitation/month or you can choose to pay annually, where you get half price and pay 12 kr. per invitation/month billed annually.</p>

						<p><strong>When can I cancel my subscription?</strong></p>
						<p>You can cancel your subscription at the end of the subscription period. A subscription is valid for 1 year, so you can cancel it at the end of your subscription period.<br />
						When you cancel your subscription, it will stop at the end of the month you cancel your subscription.</p>

						<p><strong>What happens to my unused invitations?</strong></p>
						<p>Unused invitations cannot be transferred to the next subscription or game. It is therefore important to use your invitations so you don't miss the opportunity to activate them.</p>

						<p><strong>Is there a limit to how many games I can create with the premium invitations?</strong></p>
						<p>No, as premium you can create an unlimited number of games, however, you can only have the number of invitations active that you have purchased. This means that if you have purchased 10 invitations, you can have, for example, 2 games with 5 on each, but you cannot have 2 games with 10 on each.</p>
						</T>
					</Col>
			</Row>
		</Container>
	);
}

const Premium = (props) => <AUAContainer><PremiumInner {...props}/></AUAContainer>;

export default Premium;


// WEBPACK FOOTER //
// ./src/p/Premium.js